// dashboard/FilterBar.js
// Extracted from App.js (2026-08-12 split).

import { useTranslation } from 'react-i18next';
import { c } from './constants';
import ConditionMultiSelect from './ConditionMultiSelect';

export default function FilterBar({ filters, setFilters, vets, conditions, profile, onSetDefault }) {
  const { t } = useTranslation();
  const selStyle = {
    padding: '7px 10px',
    borderRadius: 8,
    border: `1px solid ${c.border}`,
    backgroundColor: c.white,
    fontSize: 12,
    color: c.slate,
    cursor: 'pointer',
    outline: 'none',
  };

  // A doctor's own default condition view (e.g. a cardiologist defaulting
  // to CHF only, or an internal medicine doctor watching both CHF and OA)
  // — per-profile, not per-clinic, so different specialists at the same
  // clinic each keep their own. Order-independent set comparison, since
  // toggling checkboxes can produce the same set in a different order —
  // an order-sensitive comparison would show "Set as my default" as still
  // available even when the set is unchanged.
  const currentDefault = profile?.default_condition_filters || [];
  const isCurrentDefault =
    currentDefault.length === filters.conditionTypes.length &&
    currentDefault.every(ct => filters.conditionTypes.includes(ct));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
      <label htmlFor="filter-sort" style={{ fontSize: 12, color: c.textSoft, marginRight: 2 }}>{t('filterBar.sortBy')}</label>
      <select id="filter-sort" style={selStyle} value={filters.sortBy} onChange={e => setFilters(f => ({ ...f, sortBy: e.target.value }))}>
        <option value="severity">{t('filterBar.sortSeverity')}</option>
        <option value="lastUpdated">{t('filterBar.sortLastUpdated')}</option>
        <option value="name">{t('filterBar.sortPatientName')}</option>
      </select>

      <label htmlFor="filter-clinician" style={{ fontSize: 12, color: c.textSoft }}>{t('filterBar.clinician')}</label>
      <select id="filter-clinician" style={selStyle} value={filters.clinician} onChange={e => setFilters(f => ({ ...f, clinician: e.target.value }))}>
        <option value="">{t('filterBar.allClinicians')}</option>
        {vets.map(v => <option key={v.id} value={v.id}>{t('filterBar.doctorName', { name: v.last_name })}</option>)}
      </select>

      {/* Hidden when there are no conditions at all (a brand-new clinic
          with no workflows assigned yet) — matches the guard the sidebar's
          own default-view dropdown already had; this one and the "Set as
          my default" button (which only makes sense together with it)
          previously had no equivalent guard. */}
      {conditions?.length > 0 && (
        <>
          <label htmlFor="filter-condition" style={{ fontSize: 12, color: c.textSoft }}>{t('filterBar.condition')}</label>
          <ConditionMultiSelect
            id="filter-condition"
            ariaLabel={t('filterBar.filterByCondition')}
            options={[...new Set(conditions)]}
            selected={filters.conditionTypes}
            onChange={types => setFilters(f => ({ ...f, conditionTypes: types }))}
          />

          {!isCurrentDefault && (
            <button
              onClick={() => onSetDefault(filters.conditionTypes)}
              title={t('filterBar.setDefaultTitle')}
              style={{ fontSize: 12, color: c.moss, background: 'none', border: `1px solid ${c.moss}`, borderRadius: 8, padding: '7px 10px', cursor: 'pointer' }}
            >
              {t('filterBar.setAsMyDefault')}
            </button>
          )}
        </>
      )}

      {(filters.clinician || filters.conditionTypes.length > 0) && (
        <button
          onClick={() => setFilters(f => ({ ...f, clinician: '', conditionTypes: [] }))}
          style={{ fontSize: 12, color: c.textSoft, background: 'none', border: `1px solid ${c.border}`, borderRadius: 8, padding: '7px 10px', cursor: 'pointer' }}
        >
          {t('filterBar.clearFilters')}
        </button>
      )}
    </div>
  );
}
